<div class="" fxLayout="column" fxLayoutAlign="start stretch">


    <ng-container *ngIf="!creandoEncuesta">
        <div *ngIf="procesoFinalizado" class="" fxLayout="row" fxLayoutAlign="space-evenly center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
            <div class="roundEdg done mat-elevation-z4 pr-20 pl-20 m-10" fxLayout="row" fxLayoutAlign="space-between center">
                <h2>{{'SHEDULE2_0.ENCUESTACREADA' | translate}}</h2>
                <mat-icon class="ml-20 s-30">check_circle</mat-icon>
            </div>
            <button mat-raised-button color="primary" class="wsn done" (click)="verSeccionesAgregadas()">
        {{'SHEDULE2_0.VERSECCIONES' | translate}}
        <mat-icon class="ml-20">format_list_numbered</mat-icon>
      </button>
        </div>
        <div fxLayout="row wrap" fxLayoutAlign="space-evenly start" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
            <ng-container *ngFor="let card of cards; let i = index;">
                <div *ngIf="card.visible" class="course-content m-20" fxLayout="column" fxFlex="100" fxFlex.gt-xs="40" fxFlex.gt-sm="40" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                    <div class="header accent-100" fxLayout="row" fxLayoutAlign="center center">
                        <div class="category" fxFlex>
                            {{card.titulo | translate}}
                        </div>
                    </div>
                    <div class="content m-20" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">

                        <ng-container *ngIf="i == 0">
                            <ng-container *ngIf="card.completo == false; else card1Ok">
                                <p>{{'SHEDULE2_0.CARDS.PASO1.INFO_PRE' | translate}}</p>
                                <mat-list>
                                    <mat-list-item>
                                        <p class="fz14 mr-20">{{'SHEDULE2_0.CARDS.PASO1.REQTEC' | translate}}</p>
                                        <button *ngIf="!reqTecOK" mat-mini-fab color="accent" routerLink="/requirements-detail" matTooltip="{{'SHEDULE2_0.CARDS.PASO1.REQTEC_TOOLTIP' | translate}}" matTooltipPosition="right">
                      <mat-icon>send</mat-icon>
                    </button>
                                        <div *ngIf="reqTecOK" class="roundEdg done mat-elevation-z4 p-5 mt-10 mb-10" fxLayout="row" fxLayoutAlign="space-between center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                                            <mat-icon class="s-20">done</mat-icon>
                                        </div>
                                        <mat-divider></mat-divider>
                                    </mat-list-item>
                                    <mat-list-item>
                                        <p class="fz14 mr-20">{{'SHEDULE2_0.CARDS.PASO1.LOGO' | translate}}</p>
                                        <button *ngIf="!logoOK" mat-mini-fab color="accent" matTooltip="{{'SHEDULE2_0.CARDS.PASO1.LOGO_TOOLTIP' | translate}}" matTooltipPosition="right" (click)="cargaLogoEmpresa()">
                      <mat-icon>add_a_photo</mat-icon>
                    </button>
                                        <div *ngIf="logoOK" class="roundEdg done mat-elevation-z4 p-5 mt-10 mb-10" fxLayout="row" fxLayoutAlign="space-between center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                                            <mat-icon class="s-20">done</mat-icon>
                                        </div>
                                    </mat-list-item>
                                </mat-list>
                            </ng-container>
                            <ng-template #card1Ok>
                                <p>{{'SHEDULE2_0.CARDS.PASO1.INFO_POST' | translate}}</p>
                                <mat-list>
                                    <mat-list-item>
                                        <p class="fz14 mr-20">{{'SHEDULE2_0.CARDS.PASO1.REQTEC' | translate}}</p>
                                        <div class="roundEdg done mat-elevation-z4 p-5 mt-10 mb-10" fxLayout="row" fxLayoutAlign="space-between center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                                            <mat-icon class="s-20">done</mat-icon>
                                        </div>
                                        <mat-divider></mat-divider>
                                    </mat-list-item>
                                    <mat-list-item>
                                        <p class="fz14 mr-20">{{'SHEDULE2_0.CARDS.PASO1.LOGO' | translate}}</p>
                                        <div class="roundEdg done mat-elevation-z4 p-5 mt-10 mb-10" fxLayout="row" fxLayoutAlign="space-between center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                                            <mat-icon class="s-20">done</mat-icon>
                                        </div>
                                    </mat-list-item>
                                </mat-list>
                            </ng-template>
                        </ng-container>

                        <ng-container *ngIf="i == 1">
                            <mat-form-field class="calHid">
                                <input matInput [matDatepicker]="fecLanzamiento" [matDatepickerFilter]="filtroLanzamiento" (dateChange)="fechaSeleccionada(1, $event)">
                                <mat-datepicker touchUi #fecLanzamiento></mat-datepicker>
                            </mat-form-field>
                            <ng-container *ngIf="card.completo == false; else card2Ok">
                                <p>{{'SHEDULE2_0.CARDS.PASO2_B.INFO_PRE' | translate}}</p>
                                <!-- <button mat-raised-button color="accent" (click)="fecLanzamiento.open()"> -->
                                <button mat-raised-button color="accent" (click)="verFechas()">
                  {{'SHEDULE2_0.CARDS.PASO2_B.PICKDATE' | translate}}
                  <mat-icon class="ml-20">calendar_today</mat-icon>
                </button>
                            </ng-container>
                            <ng-template #card2Ok>
                                <p>{{'SHEDULE2_0.CARDS.PASO2_B.INFO_PRE' | translate}}</p>
                                <!-- <button mat-raised-button color="accent" class="mt-20" (click)="fecLanzamiento.open()" *ngIf="!pasoCompleto"> -->
                                <button mat-raised-button color="accent" (click)="verFechas()" *ngIf="!pasoCompleto">
                  {{'SHEDULE2_0.CARDS.PASO2_B.PICKDATE' | translate}}
                  <mat-icon class="ml-20">calendar_today</mat-icon>
                </button>
                            </ng-template>
                            <ng-container *ngIf="prorrogas">
                                <p class="mt-20">{{'SHEDULE2_0.CARDS.PASO2_B.INFO_PROR' | translate}}</p>
                                <!-- <button mat-raised-button color="accent" (click)="fecLanzamiento.open()"> -->
                                <button mat-raised-button color="accent" (click)="verProrrogas()">
                    {{'SHEDULE2_0.CARDS.PASO2_B.PRORROGAS' | translate}}
                    <mat-icon class="ml-20">zoom_in</mat-icon>
                  </button>
                            </ng-container>
                        </ng-container>

                        <!-- update fecha Cierre -->
                        <ng-container *ngIf="i == 2">
                            <mat-form-field class="calHid">
                                <input matInput [matDatepicker]="fecLanzamiento" [matDatepickerFilter]="filtroLanzamiento" (dateChange)="updatefechaCierre($event)" [value]="fechaCierre">
                                <mat-datepicker touchUi #fecLanzamiento></mat-datepicker>
                            </mat-form-field>
                            <p>{{'SHEDULE2_0.CARDS.PASO2.INFO_POST' | translate}}</p>
                            <b>{{fechaCierre | slice: 0:10 | date:"fullDate":'':idiomaActual}}</b>
                            <button mat-raised-button color="accent" class="mt-20" (click)="fecLanzamiento.open()" *ngIf="!pasoCompleto" [disabled]="procesoFinalizado || !fechaLanzamiento ">
                  {{'SHEDULE2_0.CARDS.PASO2.CHANGE' | translate}}
                  <mat-icon class="ml-20">calendar_today</mat-icon>
                </button>

                            <ng-container *ngIf="prorrogas">
                                <mat-expansion-panel style="margin-top:10px">
                                    <mat-expansion-panel-header style="width:100%; background-color: #b3aeae">
                                        <mat-panel-title>
                                            <h6>{{'SHEDULE2_0.CARDS.PASO2.LIS-PRORRO' | translate}}</h6>
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <!--------- PICK DATE ------->
                                    <mat-list>
                                        <mat-list-item *ngFor="let prorrogas of prorrogasEncuesta;  let i = index">
                                            <p mat-line> {{prorrogas.fecha |date:"fullDate":'':idiomaActual}} </p>
                                        </mat-list-item>
                                        <mat-divider></mat-divider>
                                    </mat-list>
                                    <!------- boton  --------->
                                </mat-expansion-panel>

                            </ng-container>
                        </ng-container>

                        <ng-container *ngIf="i == 3">
                            <p>{{'SHEDULE2_0.CARDS.PASO3.INFO_PRE' | translate}}</p>
                            <b>{{'SHEDULE2_0.CARDS.PASO3.INFO_POST' | translate}}</b>
                            <mat-form-field class="calHid">
                                <input matInput [matDatepicker]="fecRecordatorio" [matDatepickerFilter]="filtroRecordatorios" (dateChange)="fechaSeleccionada(2, $event)">
                                <mat-datepicker touchUi #fecRecordatorio></mat-datepicker>
                            </mat-form-field>
                            <div class="" fxLayout="column" fxLayoutAlign="start stretch">
                                <button mat-raised-button color="accent" class="wsn mt-10" (click)="selRecordatorio()" [disabled]="procesoFinalizado">
                  {{'SHEDULE2_0.CARDS.PASO3.NUEVO' | translate}}
                  <mat-icon class="ml-20">add_alert</mat-icon>
                </button>
                                <button mat-raised-button color="accent" class="wsn mt-10" (click)="verRecordatorios()">
                  {{'SHEDULE2_0.CARDS.PASO3.LISTA' | translate}}
                  <mat-icon class="ml-20">format_list_numbered</mat-icon>
                </button>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="i == 4">
                            <p>{{'SHEDULE2_0.CARDS.PASO4.INFO_PRE' | translate}}</p>
                            <button mat-raised-button color="accent" class="wsn" (click)="irPaso(1)">
                {{'SHEDULE2_0.CARDS.PASO4.VERMENSAJES' | translate}}
                <mat-icon class="ml-20">email</mat-icon>
              </button>
                        </ng-container>

                    </div>
                    <div class="footer" fxLayout="row" fxLayoutAlign="space-between center">
                        <ng-container *ngIf="card.completo == false  && !fechaLanzamiento">
                            <div class="h4 secondary-text"><b>{{'SHEDULE2_0.CARDS.STATUS.PENDING' | translate}}</b></div>
                            <div class="roundEdg undone mat-elevation-z4 p-5 m-10" fxLayout="row" fxLayoutAlign="space-between center">
                                <mat-icon class="s-20">priority_high</mat-icon>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="card.completo == true || fechaLanzamiento && fechaCierre">
                            <div class="h4 secondary-text"><b>{{'SHEDULE2_0.CARDS.STATUS.OK' | translate}}</b></div>
                            <div class="roundEdg done mat-elevation-z4 p-5 m-10" fxLayout="row" fxLayoutAlign="space-between center">
                                <mat-icon class="s-20">done</mat-icon>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="card.opcional == true">
                            <div class="h4 secondary-text"><b>{{'SHEDULE2_0.CARDS.STATUS.OPT' | translate}}</b></div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
        </div>

        <button *ngIf="!procesoFinalizado" mat-raised-button color="primary" class="wsn" (click)="preCrearEncuesta()">
      {{'SHEDULE2_0.CREAR' | translate}}
      <mat-icon class="ml-20">play_arrow</mat-icon>
    </button>
    </ng-container>


    <div *ngIf="creandoEncuesta" class="tac" fxLayout="column" fxLayoutAlign="start stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
        <div *ngIf="procesoFinalizado" fxLayout="row" fxLayoutAlign="start center" class="mt-20">
            <button mat-raised-button color="accent" (click)="verSeccionesAgregadas()">
        <mat-icon class="mr-20">arrow_back</mat-icon>
        {{'SHEDULE2_0.BACK' | translate}}
      </button>
        </div>
        <h3 *ngIf="!procesoFinalizado" class="mb-20">{{'SHEDULE2_0.CREANDO' | translate}}</h3>
        <div class="" fxLayout="row" fxLayoutAlign="space-between stretch">
            <ng-container *ngFor="let seccion of secciones">
                <div *ngIf="seccion.visible" fxFlex="{{tamanioTagSecc}}" fxLayout="column" fxLayoutAlign="space-between center">
                    <!-- <div class="roundEdg iconoSeccion mat-elevation-z4 p-5 m-10" fxLayout="row" fxLayoutAlign="space-between center"> -->
                    <div class="p-5 m-10" fxLayout="row" fxLayoutAlign="space-between center">
                        <mat-icon class="s-30">{{seccion.icono}}</mat-icon>
                    </div>
                    <b>{{seccion.titulo | translate}}</b>
                    <div *ngIf="!seccion.completo && !seccion.fallo" class="roundEdg undone mat-elevation-z4 p-5 m-10" fxLayout="row" fxLayoutAlign="space-between center">
                        <mat-icon class="s-20">more_horiz</mat-icon>
                    </div>
                    <div *ngIf="seccion.completo" class="roundEdg done mat-elevation-z4 p-5 m-10" fxLayout="row" fxLayoutAlign="space-between center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                        <mat-icon class="s-20">done</mat-icon>
                    </div>
                    <div *ngIf="!seccion.completo && seccion.fallo" class="roundEdg fail mat-elevation-z4 p-5 m-10" fxLayout="row" fxLayoutAlign="space-between center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                        <mat-icon class="s-20">close</mat-icon>
                    </div>
                </div>
            </ng-container>
        </div>
        <mat-progress-bar mode="buffer" value="{{progresoEncuesta}}"></mat-progress-bar>
        <h3 *ngIf="procesoActual!= ''" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}"><b>{{procesoActual | translate}}</b></h3>
        <div *ngIf="procesoFinalizado && !procesoOK" fxLayout="row" fxLayoutAlign="center stretch" [@animate]="{value:'*',params:{delay:'500ms', y:'25px'}}">
            <button mat-raised-button color="accent" class="wsn" (click)="crearEncuesta()">
        {{'SHEDULE2_0.RETRY' | translate}}
        <mat-icon class="ml-20">replay</mat-icon>
      </button>
        </div>
    </div>

</div>
<div *ngIf="procesoFinalizado && procesoOK" fxLayout="row" fxLayoutAlign="end end" class="mb-20 finishBt">
    <button *ngIf="!pasoCompleto" (click)="completarPaso()" mat-fab aria-label="boton completar paso" matTooltip="{{'SHEDULE.COMPLETAR_PASO' | translate}}" matTooltipPosition="left" class="undone mr-20">
    <mat-icon>done</mat-icon>
  </button>
    <button *ngIf="pasoCompleto" (click)="completarPaso()" mat-raised-button class="done mr-20">
    {{'SHEDULE.PASO_COMPLETADO' | translate}}
    <mat-icon class="ml-20">done</mat-icon>
  </button>

    <!-- desbloquearPaso -->
    <button *ngIf="pasoCompleto && (validationUser || desbloqueoEstatus)" (click)="desbloquearProgramacion()" mat-fab aria-label="" matTooltip="{{'SHEDULE.LOCK' | translate}}" matTooltipPosition="left" class="undone mr-20">
    <mat-icon>lock_open</mat-icon>
  </button>

    <button *ngIf="!pasoCompleto && (validationUser || desbloqueoEstatus)" (click)="desbloquearProgramacion()" mat-raised-button class="reopen mr-20">
    {{'SHEDULE.UNLOCK' | translate}}
    <!-- <mat-icon class="ml-20">lock_open</mat-icon> -->
  </button>
</div>
